import api from './api';
import file from './file';
import reCAPTCHA from './reCAPTCHA';

export default { api, file, reCAPTCHA };
